import {putAllRoleScenicAreaId, getAllRoleScenicAreaId} from '../../../../api/eastCoastDataApi/scenicPlace/RoleToScenicArea'
import Utils from '../../../../utils/utils'
import CONST from '../../../../utils/const'

const state = {
  allRoleScenicArea: []
}

const getters = {
  
}

const actions = {
  async getAllRoleScenicAreaId({commit}, condition ={}) {
    const result = await getAllRoleScenicAreaId()
    if (result.success) {
      commit('getAllRoleScenicArea', result)
    }
  },

  async putAllRoleScenicAreaId({commit}, condition ={}) {
    const result = await putAllRoleScenicAreaId(condition)
    if (result.success) {
      commit('updateRoleScenicArea', { data: result.data, mode: 'put' })
    }

    return result
  }
}

const mutations = {
  getAllRoleScenicArea(state, result) {
    if(Utils.isEmptyObject(result.data)) {
      return
    }

    state.allRoleScenicArea = result.data
  },

  updateRoleScenicArea(state, { data, mode }) {
    switch (mode) {
      case 'post':
        state.allRoleScenicArea.push(data)
        break
      
      case 'put':
        let target = state.allRoleScenicArea.find(d => d.roleId === data.roleId)
        if(Utils.isEmptyObject(target)) {
          state.allRoleScenicArea.push(data) //新增的角色設定權限會找不到target
        } else {
          target.scenicAreaIds = data.scenicAreaIds  // target = data, state.allRoleScenicArea的值不會改變
        }
        
        break
  
      case 'delete' :
        state.allRoleScenicArea = state.allRoleScenicArea.filter(d => d.id !== data)
        break    
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}